import { graphql } from 'gql'

export const WORKSPACE_GENERAL_CONFIGURATION_FRAGMENT = graphql(`
  fragment WorkspaceGeneralConfigurationFragment on WorkspaceGeneralConfiguration {
    id
    newDomainsDefaultBranch
  }
`)
